// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__Layout__1RDCZ{display:flex;flex-direction:column;padding:var(--Space-12) var(--Space-24);padding-bottom:calc(var(--Space-24) * 2 + 3rem + env(safe-area-inset-bottom, 0px))}.styles-module__Label__osjxN{height:39px;display:flex;align-items:center;margin-top:.5rem}.styles-module__Link__LwGns{cursor:pointer}.styles-module__Footer__2jlUe{position:fixed;bottom:0;left:0;right:0;padding:var(--Space-24)}", ""]);
// Exports
exports.locals = {
	"Layout": "styles-module__Layout__1RDCZ",
	"Label": "styles-module__Label__osjxN",
	"Link": "styles-module__Link__LwGns",
	"Footer": "styles-module__Footer__2jlUe"
};
export default exports;
